module.exports = __webpack_public_path__ + "main/assets/fonts/petalmd/petalmd-59850369e483aec907615674b2ec3c51.ttf";


//////////////////
// WEBPACK FOOTER
// ./main/assets/fonts/petalmd/petalmd.ttf
// module id = 469
// module chunks = 0